import { FunctionComponent } from 'react';

type Props = {
    type: string,
    width?: number,
    height?: number,
    className?: string,
    color?: string
}

const Icon: FunctionComponent<Props> = ({type, width, height, className, color}) => {
    const props = { width, height, className };
    const iconColor = color || '#000000';
    
    switch (type) {
        case 'attachment':
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
                <path d="M67.508 468.467c-58.005-58.013-58.016-151.92 0-209.943l225.011-225.04c44.643-44.645 117.279-44.645 161.92 0 44.743 44.749 44.753 117.186 0 161.944l-189.465 189.49c-31.41 31.413-82.518 31.412-113.926.001-31.479-31.482-31.49-82.453 0-113.944L311.51 110.491c4.687-4.687 12.286-4.687 16.972 0l16.967 16.971c4.685 4.686 4.685 12.283 0 16.969L184.983 304.917c-12.724 12.724-12.73 33.328 0 46.058 12.696 12.697 33.356 12.699 46.054-.001l189.465-189.489c25.987-25.989 25.994-68.06.001-94.056-25.931-25.934-68.119-25.932-94.049 0l-225.01 225.039c-39.249 39.252-39.258 102.795-.001 142.057 39.285 39.29 102.885 39.287 142.162-.028A739446.174 739446.174 0 0 1 439.497 238.49c4.686-4.687 12.282-4.684 16.969.004l16.967 16.971c4.685 4.686 4.689 12.279.004 16.965a755654.128 755654.128 0 0 0-195.881 195.996c-58.034 58.092-152.004 58.093-210.048.041z" />
            </svg>
        case 'alert':
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props} fill="none">
                <circle cx="12" cy="17" r="1" fill={iconColor} />
                <path d="M12 10L12 14" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3.44722 18.1056L10.2111 4.57771C10.9482 3.10361 13.0518 3.10362 13.7889 4.57771L20.5528 18.1056C21.2177 19.4354 20.2507 21 18.7639 21H5.23607C3.7493 21 2.78231 19.4354 3.44722 18.1056Z" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        case 'check':
            return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props} fill="none">
                <circle cx="12" cy="12" r="10" stroke={iconColor} strokeWidth="2" />
                <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        default:
            return null
    }
}

export default Icon